<template>
  <div class="header-bar">
    <div class="logo-and-nav">
      <div class="logo">
        <img src="@/assets/Logo.png" alt="Dave Bennett Distribution Logo"/>
      </div>
      <branded-box class="nav-wrapper">
        <div class="email">
          <svg-icon icon="envelop" width="18px" height="18px"/>
          <a href="mailto:enquiries@dave-bennett.co.uk">enquiries@dave-bennett.co.uk</a>
        </div>
        <nav class="nav">
          <ul class="nav-list">
            <li class="nav-list__item" v-for="(route) in routes">
              <router-link :to="route.path">{{route.name}}</router-link>
            </li>
          </ul>
        </nav>
      </branded-box>
    </div>
  </div>
</template>

<script>

  import '@/assets/icons/envelop'
  import BrandedBox from "./branded-box";

  import {routes} from "../router/index"

  export default {
    components: {BrandedBox},
    computed : {
      routes() {
        return routes;
      }
    },
  }

</script>

<style lang="scss" scoped="scoped">

  @import "/../assets/scss/palette";



  $logo-height: 60px;
  $logo-bottom-margin: 1em;
  $logo-and-nav-height: calc(#{$logo-height} + #{$logo-bottom-margin});
  $navbar-height: calc(#{$logo-and-nav-height} /2 );
  $contact-height: calc(#{$logo-and-nav-height} - #{$navbar-height});

  .header-bar {

    margin-bottom: 1rem;

    .logo-and-nav {

      display: flex;

    }

    .logo {

      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

    }

    .nav-wrapper {
      height: $logo-and-nav-height;
      display: flex;
      flex-flow: column;
      margin-left: 1em;
      flex: 1;
      min-width: 50%;
    }

    .email {
      height: calc(#{$contact-height} - 1em);
      display: flex;
      justify-content: flex-end;
      padding: 0.5em 1em;
    }

    .nav {
      width: 100%;
    }

    .nav-list {

      list-style: none;

      display: flex;
      justify-content: space-between;
      margin: 0;

      height: $navbar-height;
      padding-left: 1rem;
      padding-right: 1rem;

      &__item {
        line-height: $navbar-height;

        a {
          height: calc(#{$navbar-height} - 3px);
          margin-bottom: 3px;
          padding: 0 0.5em;
          display: block;
          text-decoration: none;
          transition: all 0.3s ease-in-out;
        }


        a.router-link-exact-active, a:hover {
          border-bottom: $orange 3px solid;
        }

      }

    }

  }

  @media (max-width: 1000px) {

    .logo  {

      margin-bottom: 1rem;

      img {
        max-height: none !important;
        width: 100% !important;
      }

    }

    .logo-and-nav {
      flex-flow: column;
      margin-top: 1rem;
    }

    .nav-wrapper {
      margin-left: 0 !important;
      height: auto !important;
      align-items: center;
      min-width: auto !important;
    }

    .email {
      display: none !important;
    }

    .nav-list {

      height: auto !important;

      &__item a {
        font-size: 2rem;
        height: auto !important;
      }
    }
  }

  @media (max-width: 700px) {
    .nav-list {
      flex-flow: column;
      align-items: center;

      &__item {
        margin-left: 0 !important;
      }
    }
  }



</style>